<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="1100"
      :before-close="() => $refs.main.cancel()"
      :close-on-press-escape="false"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :selectionCode="selectionCode"
          :expoMeetingCode="expoMeetingCode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    title: { type: String, default: '' },
    selectionCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return ['detail'].includes(this.type)
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-drawer__header {
    margin-bottom: 17px;
  }
}
.drawer-main {
  padding: 0 20px 20px;
  // > div {
  //   padding: 15px;
  //   border: 1px solid #bbbbbb;
  //   border-radius: 8px;
  // }
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
